import { LOGIN_BASE_URL, LoginCall } from "./helper";

export const loginApi = async (credentials) => {
  try {
    const data = await LoginCall(`${LOGIN_BASE_URL}`, {
      method: "POST",
      data: credentials,
    });

    if (!data?.data?.token) throw new Error("No token found");
    else {
      sessionStorage.setItem('token', data?.data?.token);
      sessionStorage.setItem('apiKeyGQL', data?.data?.apiKeyGPL)
      sessionStorage.setItem('user', JSON.stringify(data?.data))
      sessionStorage.setItem('userType', parseInt(JSON.stringify(data?.data.userTypeId)) === 9 ? 'CareTeam' : 'OrgAdmin')
    }
    return data;
  } catch (error) {
    console.error("Login API Error:", error.message);
    throw error;
  }
};

